import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  [theme.breakpoints.down('sm')]: {
    mainContainer: {
      flexDirection: "column-reverse",
    },
    warningBanned: {
      color : 'white',
      overflowWrap : 'break-word' 
    }
  },

}));